// Service API public pour récupérer les Certifications
export interface PublicCertification {
    id: string;
    title: string;
    issuer: string;
    type: 'certification' | 'badge';
    date: number;
    imageUrl: string;
    url: string;
    description: string;
    credentialId: string;
}

const API_BASE = '/api/certifications';

export async function getPublicCertifications(): Promise<PublicCertification[]> {
    const response = await fetch(API_BASE);

    if (!response.ok) {
        console.error('Failed to fetch certifications');
        return [];
    }

    const data = await response.json();
    return data.certifications;
}
